import { getMyProfile } from "api/user";
import { useMutation } from "react-query";

function useGetMyProfile() {
  return useMutation(getMyProfile, {
    onError: (err) => {
      console.log(err.message);
    },
  });
}

export { useGetMyProfile };
